import { type Components, type Theme } from "@mui/material/styles";

export const chip: Components<Theme>["MuiChip"] = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: () => ({
      width: "fit-content",
      padding: "0 4px",
    }),
    label: () => ({
      padding: "0 6px",
    }),
  },
  variants: [
    {
      props: { variant: "filter" },
      style: ({ theme }) => ({
        ...theme.typography.body3,
        fontWeight: 400,
        height: 30,
        borderRadius: 9999,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px dashed ${theme.palette.divider}`,
        padding: theme.spacing(0, 1.25),
        gap: theme.spacing(0.75),
        width: "auto",
        transition: "none",
        "&:hover": {
          backgroundColor: theme.palette.primary._states.hover,
        },
        "&.MuiChip-clickable:focus, &.MuiChip-clickable:active, &.Mui-focusVisible":
          {
            boxShadow: "none",
          },
        "& .MuiChip-label": {
          padding: 0,
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          color: "inherit",
        },
        "& .MuiChip-icon": {
          margin: 0,
          width: 12,
          height: 12,
          fontSize: 12,
          color: "inherit",
        },
        "& .MuiChip-deleteIcon": {
          margin: 0,
          width: 13,
          height: 13,
          fontSize: 13,
          color: "inherit",
          fontWeight: 400,
          transition: "none",
          "--svg-icon-stroke": "0",
          "&:hover": {
            color: "inherit",
            fontWeight: 700,
            backgroundColor: "transparent",
            "--svg-icon-stroke": "0.6px",
          },
          "&:active": {
            fontWeight: 700,
            backgroundColor: "transparent",
            "--svg-icon-stroke": "0.6px",
          },
        },
      }),
    },
    {
      props: { variant: "filter", color: "primary" },
      style: ({ theme }) => ({
        borderStyle: "solid",
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary._states.selected,
        color: theme.palette.primary.dark,
        "&:hover": {
          backgroundColor: theme.palette.primary._states.focus,
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.dark,
        },
        "&.MuiChip-clickable:focus, &.MuiChip-clickable:active, &.Mui-focusVisible":
          {
            backgroundColor: theme.palette.primary._states.focus,
            color: theme.palette.primary.dark,
            boxShadow: "none",
          },
        "& .MuiChip-deleteIcon:hover": {
          backgroundColor: "transparent",
          color: theme.palette.primary.dark,
          fontWeight: 700,
          "--svg-icon-stroke": "0.6px",
        },
      }),
    },
  ],
};
